const VERIFY = "[VERIFY WITH SABAKT] Detailed technical specifications, grades and available dimensions to be confirmed by SABAKT engineering.";

export const PROJECTS_NOTE =
  "Case studies illustrated with actual SABAKT workshop photographs. Client names and project figures are withheld pending approval.";

export const PROJECTS = [
  {
    slug: "bucket-wear-packages",
    title: "Excavator & Loader Bucket Wear Packages",
    industry: "Mining & Quarry",
    location: "Saudi Arabia",
    image: "/images/cement/c19.jpg",
    gallery: ["/images/cement/c18.jpg", "/images/cement/c20.jpg", "/images/cement/c16.jpg"],
    requirement: "Quarry and mining buckets reaching end of wear life — worn lips, thinned floors and abraded side walls — with long lead times and high cost on replacement buckets.",
    challenge: "Restore bucket geometry and upgrade wear protection across multiple machine classes without extended fleet downtime.",
    solution: "Sequential reconditioning program: inspection, crack repair, dimensional restoration of edges and lips, followed by engineered hardfacing patterns and wear-package application.",
    materials: "Hardfacing consumables (Diffusion Engineers range), wear-resistant plate",
    scope: "Inspection → crack repair → structural restoration → hardfacing → dimensional restoration → finishing",
    result: "Buckets returned to service with restored profiles and upgraded wear protection. [Figures to be verified with SABAKT]",
  },
  {
    slug: "crusher-wear-hardfacing",
    title: "Crusher Wear Parts & Hardfacing Program",
    industry: "Cement",
    location: "Saudi Arabia",
    image: "/images/cement/c05.jpg",
    gallery: ["/images/cement/c09.jpg", "/images/cement/c02.jpg", "/images/cement/c14.jpg"],
    requirement: "Crusher wear components and plant liners wearing out between planned stops, forcing emergency repairs and patch maintenance.",
    challenge: "Extend component life to match the plant's planned maintenance interval using the correct hardfacing and wear materials.",
    solution: "Supply and reconditioning of crusher wear parts with application-matched hardfacing; hardfaced wear plates fabricated and drilled for direct installation.",
    materials: "Hardfacing consumables (Diffusion Engineers range)",
    scope: "Wear assessment → consumable selection → hardfacing / reconditioning → dimensional check → delivery",
    result: "Wear response moved from emergency repair to planned maintenance. [Figures to be verified with SABAKT]",
  },
  {
    slug: "mixer-wear-parts-supply",
    title: "Batching Plant Mixer Wear Parts Supply",
    industry: "Concrete & Block",
    location: "Saudi Arabia",
    image: "/images/concrete/b09.jpg",
    gallery: ["/images/concrete/b29.jpg", "/images/concrete/b11.jpg", "/images/concrete/b26.jpg"],
    requirement: "Ready-mix and block plants needing reliable local supply of mixer wear parts — arms, blades, scrapers, liners and table sheets — without import lead times.",
    challenge: "Produce brand-compatible parts with correct fit, verified against OEM samples and site measurements.",
    solution: "Reverse engineering, site inspection and dimension verification, followed by local manufacture of wear-resistant replacement parts with on-site installation support.",
    materials: "Wear-resistant cast alloys and plate",
    scope: "Site inspection → dimension verification → manufacture → supply → installation support",
    result: "Brand-compatible parts (Liebherr, BHS, SICOMA, ELBA, MASA, HESS, MEKA) supplied locally with reduced downtime.",
  },
  {
    slug: "diesel-water-tanks",
    title: "Diesel & Water Storage Tank Fabrication",
    industry: "Infrastructure",
    location: "Saudi Arabia",
    image: "/images/steel/s53.jpg",
    gallery: ["/images/steel/s54.jpg", "/images/steel/s56.jpg", "/images/steel/s60.jpg"],
    requirement: "Project sites requiring diesel and water storage tanks with full ancillary steelwork — supports, ladders, nozzles and pipe interfaces.",
    challenge: "Deliver tanks fabricated to project specification as one coordinated package with all associated steelwork.",
    solution: "Tank fabrication with saddles, access ladders, platforms, handrails and nozzle interfaces manufactured to project dimensions and site conditions.",
    materials: "Carbon steel to project specification",
    scope: "Tank shells & ends → supports & saddles → ladders & platforms → nozzles & pipe interfaces",
    result: "Delivered as complete fabrication packages per project requirements. Designed and fabricated according to applicable project specifications and required standards.",
  },
  {
    slug: "silo-fabrication-delivery",
    title: "Cement Silo Fabrication & Delivery",
    industry: "Concrete & Block",
    location: "Saudi Arabia",
    image: "/images/steel/s02.jpg",
    gallery: ["/images/steel/s22.jpg", "/images/steel/s10.jpg", "/images/steel/s04.jpg"],
    requirement: "Batching plants requiring cement silos with cones and support structures, transportable to site and matched to plant layout.",
    challenge: "Fabricate large-diameter silo shells and cones with transport-friendly sectional construction and true fit-up on site.",
    solution: "Workshop fabrication of silo shells, cones and support steelwork, with sectional designs for transport and site assembly.",
    materials: "Carbon steel plate, structural sections",
    scope: "Shell rolling → cone forming → support fabrication → surface preparation → delivery",
    result: "Silos delivered and installed to plant layout. [Details to be verified with SABAKT]",
  },
  {
    slug: "platforms-structural-steelwork",
    title: "Platforms, Stairs & Structural Steelwork",
    industry: "Manufacturing",
    location: "Riyadh, KSA",
    image: "/images/steel/s26.jpg",
    gallery: ["/images/steel/s16.jpg", "/images/steel/s35.jpg", "/images/steel/s50.jpg"],
    requirement: "Industrial facilities requiring access platforms, steel stairs, structural frames and equipment supports for expansions and upgrades.",
    challenge: "Fabricate to engineer's drawings with site-verified dimensions to ensure first-time fit during installation.",
    solution: "Shop-fabricated platforms, stairs, handrails, frames and supports with site measurement verification before fabrication.",
    materials: "Structural carbon steel",
    scope: "Site survey → fabrication → surface preparation & coating → delivery",
    result: "Installed without site modification. [Details to be verified with SABAKT]",
  },
];
